import { validateLoanStartDate } from '../../validation';
/**
 * Loan Start Date Input
 */

export var loanStartDate = {
  name: 'loanStartDate',
  type: 'string',
  validators: [validateLoanStartDate]
};